import { makeAnalyticsData } from '@atlassian/mpac-analytics';
import { DETERMINING_INSTALL_MODE_ERROR } from '../../../actions/Installation/InstallMode/DeterminingInstallMode';
import { foldInstallableAppIdentifier } from '../../../records/InstallableAppIdentifier';
import { ANALYTICS_CATEGORY_INSTALL, FetchAppDetailsFailedEvent } from '../../Events';
export default function DeterminingInstallModeMapper(action) {
  switch (action.type) {
    case DETERMINING_INSTALL_MODE_ERROR:
      return makeAnalyticsData({
        eventType: FetchAppDetailsFailedEvent,
        category: ANALYTICS_CATEGORY_INSTALL,
        actionSubjectId: foldInstallableAppIdentifier(action.installableAppId)(installableAppByKeyId => installableAppByKeyId.key, installableAppByUrlId => installableAppByUrlId.url, installableAppByARI => installableAppByARI.ari),
        attributes: {
          error: action.error
        }
      });
  }
}